<template>
  <div v-if="editModel">
    <el-form
      ref="form"
      :size="$xUISize"
      :model="editModel"
      :rules="editRules"
      @submit.native.prevent
      label-width="auto"
      label-position="top"
    >
      <el-card v-loading="loading" shadow="hover">
        <div style="padding: 10px 20px">
          <el-form-item label="摄像头名称" prop="name">
            <el-input placeholder="请输入摄像头名称" v-model="editModel.name"></el-input>
          </el-form-item>
          <el-form-item label="位置描述" prop="pos">
            <el-input
              v-model="editModel.pos"
              placeholder="请输入位置描述：如店门口"
            ></el-input>
          </el-form-item>
          <el-form-item label="摄像头类型" prop="cameraType">
            <el-select v-model="editModel.cameraType" style="width: 100%">
              <el-option label="萤石摄像头" value="ys7-camera"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备系列号" prop="deviceSerial">
            <el-input
              v-model="editModel.deviceSerial"
              placeholder="请输入设备系列号"
            ></el-input>
          </el-form-item>
          <el-form-item label="其他选项" prop="moreExtras">
            <div class="borderBox">
              <el-checkbox v-model="editModel.isVoice" :true-label="1" :false-label="0">
                语音播报
              </el-checkbox>
              <div v-if="editModel.isVoice == 1">
                <el-input
                  type="textarea"
                  v-model="editModel.voiceScene"
                  placeholder="请输入语音播报模板：open_door,help_guide"
                  maxlength="256"
                  :rows="2"
                ></el-input>
                <span>
                  *
                  语音播报模板按格式填写：open_door(开门播报)，help_guide(引导播报)，order_guide(订单播报)，同时支持多个播报时，英文逗号分割
                </span>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="排序编号" prop="optSort">
            <el-input
              type="number"
              v-model="editModel.optSort"
              placeholder="请输入排序编号"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item label="备注说明" prop="optRemark">
            <el-input
              type="textarea"
              v-model="editModel.optRemark"
              :rows="4"
              maxlength="256"
              placeholder="输入备注说明内容"
              show-word-limit
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              :loading="editSubmit"
              @submit.native.prevent
              @click="submitClick"
            >
              保存
            </el-button>
          </el-form-item>
        </div>
      </el-card>
    </el-form>
  </div>
  <el-card v-else-if="!loading" shadow="hover">
    <el-empty :description="errorMsg" :image-size="100">
      <el-button v-if="errorMsg" @click="fetchModel" size="small"> 重新加载 </el-button>
    </el-empty>
  </el-card>
</template>

<style lang="less" scoped>
.borderBox {
  border-radius: 4px;
  border: 1px solid #dedede;
  padding: 20px;

  &:hover {
    border: 1px solid #cecece;
  }
}
</style>

<script>
const defaultModel = {
  name: "",
  pos: "",
  optStatus: 1,
};

export default {
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    query: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    pageParams() {
      return Object.assign({}, (this.$route && this.$route.params) || {}, this.params);
    },
    pageQuery() {
      return Object.assign({}, (this.$route && this.$route.query) || {}, this.query);
    },
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      editSubmit: false,
      editModel: null,
      editRules: {
        name: [
          {
            required: true,
            message: "请输入摄像头名称",
            trigger: "change",
          },
        ],
      },
    };
  },
  methods: {
    submitClick() {
      this.$refs.form.validate((valid, data) => {
        if (valid) {
          this.editSubmit = true;
          const method = this.editModel.guid
            ? "biz.customer.store.camera.update"
            : "biz.customer.store.camera.create";
          this.requestApi(method, this.editModel, {
            showError: true,
          })
            .then((resp) => {
              this.success("保存成功");
              this.$drawer.refreshDrawer();
              this.$drawer.backDrawer();
            })
            .finally(() => {
              this.editSubmit = false;
            });
        } else {
          this.showValidate(data);
        }
      });
    },
    handleModel() {
      // nothing
      if (this.pageParams.storeGuid) {
        this.editModel.storeGuid = this.pageParams.storeGuid;
      }
    },
    fetchModel() {
      const guid = this.pageParams.guid;
      if (!guid) {
        // 新增
        this.editModel = Object.assign({}, defaultModel);
        this.handleModel();
      } else {
        // 编辑
        this.errorMsg = null;
        this.loading = true;
        this.requestApi("biz.customer.store.camera.detail", {
          guid: this.pageParams.guid,
          storeGuid: this.pageParams.storeGuid,
        })
          .then((resp) => {
            this.editModel = resp.data;
            this.handleModel();
          })
          .catch((err) => {
            this.errorMsg =
              (err && err.msg) || (err && err.message) || "连接货位器失败，请检查网络";
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
  },
  mounted() {
    this.fetchModel();
  },
};
</script>
